// Serving size utilities for pluralization and parsing

export const SERVING_UNITS = [
  { singular: "Serving", plural: "Servings" },
  { singular: "Capsule", plural: "Capsules" },
  { singular: "Tablet", plural: "Tablets" },
  { singular: "Scoop", plural: "Scoops" },
  { singular: "Packet", plural: "Packets" },
  { singular: "Gummy", plural: "Gummies" },
  { singular: "Softgel", plural: "Softgels" },
  { singular: "Teaspoon", plural: "Teaspoons" },
  { singular: "Tablespoon", plural: "Tablespoons" },
];

export function pluralize(unit, count) {
  const found = SERVING_UNITS.find((u) => u.singular.toLowerCase() === unit.toLowerCase());
  if (!found) return unit;
  return count === 1 ? found.singular : found.plural;
}

export function singularize(text) {
  const lower = text.toLowerCase();
  for (const unit of SERVING_UNITS) {
    if (lower === unit.plural.toLowerCase() || lower === unit.singular.toLowerCase()) {
      return unit.singular;
    }
  }
  // Fallback: remove trailing 's' for unknown units
  if (text.endsWith("s") && text.length > 1) {
    return text.slice(0, -1);
  }
  return text;
}

export function parseServingSize(text) {
  if (!text) return { number: null, unit: null, extra: null };

  // Match: optional number (int or decimal), optional unit, optional parenthetical
  const match = text.trim().match(/^(\d+\.?\d*)?\s*([A-Za-z]+)?(\s*\(.+\))?$/);
  if (!match) return { number: null, unit: text, extra: null };

  return {
    number: match[1] ? parseFloat(match[1]) : null,
    unit: match[2] || null,
    extra: match[3]?.trim() || null,
  };
}

export function formatServingSize(number, unit, extra = null) {
  const count = number || 1;
  const pluralizedUnit = pluralize(unit, count);
  let result = `${count} ${pluralizedUnit}`;
  if (extra) result += ` ${extra}`;
  return result;
}
